import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@app/app.config';
import { ApiResponse } from '@app/models/_base/apiResponse.model';
import { CountryModel } from '@app/models/user/country.model';
import { GenderModel } from '@app/models/user/gender.model';
import { DisplayLanguageModel } from '@app/models/user/language.model';
import { LegalModel } from '@app/models/user/legal.model';
import { UserModel } from '@app/models/user/user.model';
import { Observable } from 'rxjs';

import { LocalisationService } from './localisation.service';

@Injectable()
export class UserService {
  private data: UserModel;
  private observable: Observable<UserModel>;

  private displayLan: DisplayLanguageModel[];
  private observDisplayLan: Observable<DisplayLanguageModel[]>;
  private countries: CountryModel[];
  private observCountries: Observable<CountryModel[]>;
  private genders: GenderModel[];
  private observGenders: Observable<GenderModel[]>;
  private legal: LegalModel;
  private observLegal: Observable<LegalModel>;

  constructor(private http: HttpClient, private localisation: LocalisationService) {}

  getUser(): Observable<UserModel> {
    if (this.data) {
      return Observable.of(this.data);
    } else if (this.observable) {
      return this.observable;
    } else {
      let url = AppConfig.ApiUrl + 'user';
      this.observable = this.http
        .get<UserModel>(url)
        .map(data => {
          this.observable = null;
          this.data = data;
          if (this.data.displayLanguage) {
            this.localisation.updateCurrentLanguage(this.data.displayLanguage);
          }

          return this.data;
        })
        .share();
      return this.observable;
    }
  }

  updateUser(model: UserModel): Observable<ApiResponse> {
    let url = AppConfig.ApiUrl + 'user';

    return this.http.put<ApiResponse>(url, model).map(data => {
      let result = data;
      if (model.displayLanguage) {
        this.localisation.updateCurrentLanguage(model.displayLanguage);
      }
      this.clearCache();
      return result;
    });
  }

  clearCache() {
    this.data = null;
  }

  getDisplayLanguages(): Observable<DisplayLanguageModel[]> {
    if (this.displayLan) {
      return Observable.of(this.displayLan);
    } else if (this.observDisplayLan) {
      return this.observDisplayLan;
    } else {
      let url = AppConfig.ApiUrl + 'data/displaylanguages';
      this.observDisplayLan = this.http
        .get<DisplayLanguageModel[]>(url)
        .map(data => {
          this.observDisplayLan = null;
          this.displayLan = data;
          return this.displayLan;
        })
        .share();
      return this.observDisplayLan;
    }
  }

  getCountries(): Observable<CountryModel[]> {
    if (this.countries) {
      return Observable.of(this.countries);
    } else if (this.observCountries) {
      return this.observCountries;
    } else {
      let url = AppConfig.ApiUrl + 'data/countries';
      this.observCountries = this.http
        .get<CountryModel[]>(url)
        .map(data => {
          this.observCountries = null;
          this.countries = data;
          return this.countries;
        })
        .share();
      return this.observCountries;
    }
  }

  getGenders(): Observable<GenderModel[]> {
    if (this.genders) {
      return Observable.of(this.genders);
    } else if (this.observGenders) {
      return this.observGenders;
    } else {
      let url = AppConfig.ApiUrl + 'data/genders';
      this.observGenders = this.http
        .get<GenderModel[]>(url)
        .map(data => {
          this.observGenders = null;
          this.genders = data;
          return this.genders;
        })
        .share();
      return this.observGenders;
    }
  }

  getLegal(): Observable<LegalModel> {
    if (this.legal) {
      return Observable.of(this.legal);
    } else if (this.observLegal) {
      return this.observLegal;
    } else {
      let url = AppConfig.ApiUrl + 'data/legal';
      this.observLegal = this.http
        .get<LegalModel>(url)
        .map(data => {
          this.observLegal = null;
          this.legal = data;
          return this.legal;
        })
        .share();
      return this.observLegal;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts